module.exports = __webpack_public_path__ + "static/media/LR.2b40c813.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LR.svg
// module id = 2197
// module chunks = 7